import { useHistory } from 'react-router-dom';
import Box from '@mui/material/Box';
import GoogleLogin from 'components/Login/LoginForm/GoogleLogin/GoogleLogin';
import { ConnectLoginSignUpPageDataTestIds } from 'data-testids/ConnectDataTestIds';
import { useGoogleSignIn } from 'hooks/useGoogleSignIn';
import { nimbleProduct } from 'types/types';

interface GoogleLoginSignUpPageButtonProps {
  setError: (error: { hasError: boolean; errorMessage: string }) => void;
  continueToUrl: string;
  signupAction?: string;
  redirectState?: string;
}

export function GoogleLoginSignUpPageButton({
  setError,
  continueToUrl,
  signupAction,
  redirectState,
}: GoogleLoginSignUpPageButtonProps): React.ReactElement {
  const history = useHistory();

  const { handleGoogleSignIn } = useGoogleSignIn({
    onSuccess: () => {
      continueToUrl && history.push(continueToUrl);
    },
    onError: () => {
      setError({
        hasError: true,
        errorMessage: 'Google authentication failed. Please try again.',
      });
    },
    additionalData: {
      nimble_product: nimbleProduct.connect,
      signup_action: signupAction,
      redirect_to: continueToUrl,
      state: redirectState,
    },
  });

  const promptContainerId = 'google-signup-page-container';

  return (
    <Box id={promptContainerId} display="flex" justifyContent="center">
      <GoogleLogin
        googleSignin={handleGoogleSignIn}
        promptParentId={promptContainerId}
        dataTestId={ConnectLoginSignUpPageDataTestIds.GOOGLE_LOGIN_BUTTON}
      />
    </Box>
  );
}
